module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_plus-3f70044966a89b1f59eee271a1921278.svg";